module.exports = __webpack_public_path__ + "img/Logo-black.e275635d.svg";